const domains = {
  DESKTOP: "desktop" as const,
  METRICS: "metrics" as const,
  USERS: "users" as const,
  MAP: "map" as const,
  PROPERTY_MAP: "property-map" as const,
};

export default domains;
